// Copyright ©️ 2026 eVolve MEP, LLC

import { useMemo } from 'react';

import { Text } from '@mantine/core';

import { convertInchesToImperialString } from 'helpers/convertInchesToImperialString';
import { isNil, isNotNil } from 'helpers/isNotNil';
import { useConduits } from 'modules/Shop/EvolveFabrication/useConduits';

import type { CartBend } from '../Context/useBendCreatorCartContext';
import type { BendCreatorFormValues } from '../Context/useBendCreatorFormContext';

export const BendMaterial = ({ bend }: { bend: BendCreatorFormValues | CartBend }) => {
  const { conduitTypes, conduitSizes } = useConduits();

  const conduitType = useMemo(
    () => conduitTypes?.find(({ conduitTypeId }) => conduitTypeId === bend.conduitTypeId),
    [bend, conduitTypes],
  );
  const conduitSize = useMemo(
    () => conduitSizes?.find(({ conduitSizeId }) => conduitSizeId === bend.conduitSizeId),
    [bend, conduitSizes],
  );

  if (isNil(conduitSize) || isNil(conduitType)) return null;

  const stockLength = isNotNil(bend.materialStockLength)
    ? convertInchesToImperialString(bend.materialStockLength * 12, { inchesOnly: false })
    : null;

  return <Text span>{`${stockLength ?? ''} ${conduitType.name} ${conduitSize.name}`}</Text>;
};
